<h2>{{ 'CLIENT.VEHICLES.SERVICE_REMINDERS.SERVICE_RECORDS' | translate }}</h2>

<lin-progress-bar [isShown]="!dataSource || (dataSource.isLoading$ | async)"></lin-progress-bar>
<form [formGroup]="form">
  <lin-table [dataSource]="dataSource" matSort matSortDisabled matSortActive="date" matSortDirection="desc">
    <!-- Date -->
    <lin-table-column name="date" [label]="'CLIENT.VEHICLES.SERVICE_REMINDERS.DATE_OF_SERVICE' | translate">
      <lin-cell-text *ng="let record">{{ record.date | dayjsDate }}</lin-cell-text>
    </lin-table-column>

    <!-- Odometer -->
    <lin-table-column name="odometer">
      <lin-cell-text *ng="let record">{{ displayDistance(record.odometer | distance | number: '1.0-1') }}</lin-cell-text>
    </lin-table-column>

    <!-- Engine Hours -->
    <lin-table-column name="engineHours">
      <lin-cell-text *ng="let record">{{ displayEngineHours(record.engineHours | number: '1.0-2') }}</lin-cell-text>
    </lin-table-column>

    <!--Service cost -->
    <lin-table-column name="cost" [label]="'CLIENT.VEHICLES.SERVICE_REMINDERS.SERVICE_COST' | translate" [currencyColumn]="true">
      <lin-cell-text *ng="let record">{{ record.cost | platformCurrency }}</lin-cell-text>
    </lin-table-column>

    <!-- Files attached -->
    <lin-table-column name="filesAttached" [label]="'CLIENT.VEHICLES.SERVICE_REMINDERS.FILES_ATTACHED' | translate">
      <lin-cell-multiline-text *ng="let record">
        @for (file of record.files; track file.id) {
        <div>
          <a [href]="file.path + file.name" target="_blank">{{ file.displayName }}</a>
        </div>
        }
      </lin-cell-multiline-text>
    </lin-table-column>

    <!-- Note -->
    <ng-container matColumnDef="note">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'CLIENT.VEHICLES.NOTES' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let record" class="g-table-column-icon">
        @if (record.note) {
        <lin-tooltip label="{{ record.note }}">
          <mat-icon svgIcon="list_alt"></mat-icon>
        </lin-tooltip>
        }
      </mat-cell>
    </ng-container>

    <!-- Edit -->
    <ng-container matColumnDef="edit">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'ADMIN.ADMIN_TEAM.EDIT' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let item" class="g-table-column-icon">
        @if (isEditing[item.id]) {
        <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
        } @if (!isEditing[item.id]) {
        <button mat-icon-button (click)="edit(item)" [matTooltip]="'ADMIN.ADMIN_TEAM.EDIT' | translate">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        }
      </mat-cell>
    </ng-container>

    <!-- Delete -->
    @if (isDeleteMode) {
    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'CONFIGURATION.FLEET.DELETE' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let item" class="g-table-column-icon">
        @if (isDeleting[item.id]) {
        <mat-spinner strokeWidth="2" diameter="20" color="accent"></mat-spinner>
        } @if (!isDeleting[item.id]) {
        <button mat-icon-button (click)="delete(item)" [matTooltip]="'CONFIGURATION.FLEET.DELETE' | translate">
          <mat-icon svgIcon="delete_outline"></mat-icon>
        </button>
        }
      </mat-cell>
    </ng-container>
    }

    <mat-header-row *matHeaderRowDef="settings.columnsDisplayed; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: settings.columnsDisplayed"></mat-row>
  </lin-table>

  <lin-table-toolbar>
    <div></div>
    <mat-paginator linPaginatorDefault></mat-paginator>
  </lin-table-toolbar>
</form>

<lin-table-settings
  #settings
  class="hidden"
  [columns]="columns"
  [columnsMandatory]="columnsMandatory"
  [disableExportPDF]="true"
></lin-table-settings>
